import "./App.css";
import MyOrder from "./components/myorder/MyOrder";
import Login from "./components/login/Login";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./components/context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoutes";
import "react-toastify/dist/ReactToastify.css";
import Certificate from "./components/certificate/Certificate";
import MyProfile from "./components/MyProfile";
import Customer from "./components/customer/Customer";
import View from "./components/view/View";
import AdminCertificate from "./components/admincertificate/AdminCertificate";
import AdminProfile from "./components/AdminProfile";
import Project from "./components/Project";
import AddnewProject from "./components/AddnewProject";
import Methodologie from "./components/Methodologie";
import ViewProject from "./components/viewProject";
import AdminAllOrder from "./components/AdminAllOrder";
import AddNewMethodologie from "./components/AddNewMethodologie";
import CarbonRemovel from "./components/CarbonRemovel";
import AddNewCarbonRemovel from "./components/AddNewCarbonRemovel";

function App() {
   
  return (
    <div>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          {/* <Route path="/download"element={<ProtectedRoute allowedRoles={['user','admin']}><Download /></ProtectedRoute>    }/> */}
          <Route
            path="/myorder"
            element={
              <ProtectedRoute allowedRoles={["user"]}>
                <MyOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/certificate"
            element={
              <ProtectedRoute allowedRoles={["user"]}>
                <Certificate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-allorders"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminAllOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Customer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-certificate"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminCertificate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowedRoles={["user"]}>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-profile"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminProfile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/project"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Project />
              </ProtectedRoute>
            }
          />

          <Route
            path="/methodologie"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Methodologie />
              </ProtectedRoute>
            }
          />

          <Route
            path="/methodologie/addNewmethodology"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AddNewMethodologie />
              </ProtectedRoute>
            }
          />

          <Route
            path="/carbonremovel"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <CarbonRemovel />
              </ProtectedRoute>
            }
          />

           <Route
            path="/carbonremovel/addNewcarbon"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AddNewCarbonRemovel />
              </ProtectedRoute>
            }
          />

          <Route path="/project/addnewproject" element={<AddnewProject />} />
          <Route path="/project/viewproject" element={<ViewProject />} />
          <Route path="/customers/view" element={<View />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export function ProtectRoute(props) {
  if (localStorage.getItem("user")) {
    return props.children;
  } else {
    return <Navigate to="/" />;
  }
}
export default App;
